function homePageBrandCarouselUpdate()
{
  jQuery('.home-page .brand-carousel').slick('unslick');
  jQuery('.home-page .brand-carousel').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
    ]
  });
}

function brandPageBrandCarouselUpdate()
{
  jQuery('.page-page-brand .brand-carousel').slick('unslick');
  jQuery('.page-page-brand .brand-carousel').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
    ]
  });
}

function addCustomClassToHomePageBrandCarousel()
{
  /** Add custom class to home brand-carousel  **/
  jQuery( ".home-page .shopify-section .container" ).each(function( index ) 
  {
    if(jQuery(this).find('.brand-carousel').length !== 0)
    {
      jQuery( this ).addClass('wc_brand_carousel_container');    
    }
  });  
}

function checkIfBrandHasProductAndAddClassToLetterToHighlight()
{
  /** Check with brand has product and add class to letter to highlight **/
  jQuery( ".brands-page .brands-list .brand" ).each(function( index ) 
  {
    var className = jQuery(this).attr('class')
    console.log(className);
    className = className.split(" ");
    console.log(className);
    className = '.'+className[1];
    className = '.brands-page .azbrandstable '+className;
    console.log(className);
    jQuery( className ).addClass( "wc_brands_has_products" );
  });
}

function whenClickOnTheBrandLetter()
{
  /** When click on the brand letter **/
  jQuery( "ul.azbrandstable li.vendor-letter.wc_brands_has_products" ).click(function() 
  {
    var className = jQuery(this).attr('class')
    className = className.split(" ");
    className = '.'+className[1];
    className = '.brands-page .brands-list '+className;
    jQuery('.brands-page .brands-list .brand').hide(10);
    jQuery(className).show(10);    
  });
}

function whenClickOnAllBrands()
{
  /** When click on All brands **/
  jQuery( "ul.azbrandstable li.all-brand" ).click(function() 
  {
    jQuery('.brands-page .brands-list .brand').show(10);
  });
}

function removeSlashAndNumberFromCategoryListInSidebar()
{
  /** Remove Slash And Number From Category List In Sidebar  **/
  jQuery( ".sidebar-block_content ul.category-list li a, .product-size.option-farbe ul.size-list li a span" ).each(function( index ) 
  {
    if( jQuery(this).text() )
    {
      var wc_anchor = jQuery(this).text();
      var wc_anchor_Slash = wc_anchor.substr(0, wc_anchor.indexOf('/')); 
      //console.log( wc_anchor );      
      if(wc_anchor_Slash)
      {
        wc_anchor_Slash = parseInt(wc_anchor_Slash, 10)  
        if(wc_anchor_Slash > 0)
        {
          wc_anchor = wc_anchor.substr(wc_anchor.indexOf("/") + 1)
          jQuery(this).text(wc_anchor);
          //console.log( wc_anchor );
        }
      }
    }
  });  
}

function showSubCategoriesInCollectioTemplate()
{
  var pathname = window.location.pathname;

  if( pathname.indexOf("collections") >= 0 && pathname.indexOf("damen") >= 0 )
  {
    jQuery( ".wc_title a" ).each(function( index ) 
    {
      if( jQuery(this).attr('id').indexOf("Damen") >= 0 )
      {
        jQuery(this).show();
      } 
      else
      {
        jQuery(this).hide();
      }
    });
  }
  else if( pathname.indexOf("collections") >= 0 && pathname.indexOf("herren") >= 0 )
  {
    jQuery( ".wc_title a" ).each(function( index ) 
    {
      if( jQuery(this).attr('id').indexOf("Herren") >= 0 )
      {
        jQuery(this).show();
      } 
      else
      {
        jQuery(this).hide();
      }
    });
  }
  else
  {
    jQuery( ".wc_title a" ).each(function( index ) 
    {
      jQuery(this).hide();
    });
  }
}

function showHideCategoriesInCollestionTemplateSiderbar()
{
  var pathname = window.location.pathname;
  if( pathname.indexOf("collections") >= 0 && pathname.indexOf("damen") >= 0 )
  {
    jQuery( ".filter-group-collections ul.category-list li a" ).each(function( index ) 
    {
      var wc_text = jQuery(this).text().replace("Damen ", "");
      wc_text = wc_text.replace("Damen-", ""); 
      jQuery(this).text( wc_text );

      if( jQuery(this).attr('href').indexOf("damen") >= 0 )
      {
        jQuery(this).show();
      } 
      else
      {
        jQuery(this).hide();
      }

    });
  }
  else if( pathname.indexOf("collections") >= 0 && pathname.indexOf("herren") >= 0 )
  {
    jQuery( ".filter-group-collections ul.category-list li a" ).each(function( index ) 
    {
      var wc_text = jQuery(this).text().replace("Herren ", "");
      wc_text = wc_text.replace("Herren-", ""); 
      jQuery(this).text( wc_text );

      if( jQuery(this).attr('href').indexOf("herren") >= 0 )
      {

        jQuery(this).show();
      } 
      else
      {
        jQuery(this).hide();
      }

    });
  }
  else
  {
    jQuery( ".filter-group-collections ul.category-list li a" ).each(function( index ) 
    {
      jQuery(this).hide();
    });
  }

}
jQuery( document ).ready(function() 
{
  console.log( "document ready!" );
  jQuery('.page-footer .col-md:first-child .shop-feature-icon i').attr('class', 'fas fa-box');
  addCustomClassToHomePageBrandCarousel();
  checkIfBrandHasProductAndAddClassToLetterToHighlight();
  whenClickOnTheBrandLetter();
  whenClickOnAllBrands();  
  removeSlashAndNumberFromCategoryListInSidebar();

  showSubCategoriesInCollectioTemplate();
  showHideCategoriesInCollestionTemplateSiderbar();
  homeHeaderSlider();
  
  jQuery(document).on("click", '.page-collection .sidebar-block_content .category-list li', function(event)
  {
    //setTimeout(showSubCategoriesInCollectioTemplate, 1000);
    setTimeout(showHideCategoriesInCollestionTemplateSiderbar, 1500);
    
  });

   jQuery(document).on("click", '.page-collection .sidebar-block_content .category-list li a', function(event)
  {
      setTimeout(text_stripping, 2000);
  });

  jQuery(document).on("click", '.page-collection .sidebar-block .selected-filters li a', function(event)
  {
      setTimeout(text_stripping, 2000);
  });

  jQuery(document).on("click", '.page-collection .sidebar-block .d-flex.align-items-center a', function(event)
  {
      setTimeout(text_stripping, 2000);
  });
  
  text_stripping();
  
  jQuery('#productAccordion .panel-title a').removeAttr("href");

   jQuery('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
        && 
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = jQuery(this.hash);
        target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          jQuery('html, body').animate({
            scrollTop: target.offset().top
          }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = jQuery(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            };
          });
        }
      }
    });

});


function text_stripping()
{
    
  
  if (!jQuery("body").hasClass("page-product"))
  {
    jQuery.each(jQuery('.wc_top_description'), function (index, value) 
    {                
        var wc_top_description = jQuery(value).html();
        var n = wc_top_description.indexOf("Marke");
        jQuery(this).html(wc_top_description.slice(n).replace("Marke:", ""));
    });  
  }
  
  if (!jQuery("body").hasClass("page-product"))
  {
    // Below Code Is For Removing All Marke Line in Product Description
    if(jQuery('.wc_product_description').html())
    {
        var wc_product_descriptions_one = jQuery('.wc_product_description').html();
        var new_string = wc_product_descriptions_one.indexOf('Marke:');
        var string = wc_product_descriptions_one.substring(0, new_string);
        jQuery(".wc_product_description").html(string);
    }
  }
    

}


function set_popup_cookie()
{
    setTimeout(function()
    {
      if(jQuery(".fancybox-container").length)
      {
          jQuery.cookie("newsletter", 1);
      }
    }, 4000);
}

jQuery( window ).load(function() 
{

  console.log( "window loaded!" );
  set_popup_cookie();
  homePageBrandCarouselUpdate();
  brandPageBrandCarouselUpdate();
  showHideCategoriesInCollestionTemplateSiderbar();
  //showSubCategoriesInCollectioTemplate();
  
});

jQuery('.fixed-col_content').bind("DOMSubtreeModified",function()
{
  //alert('changed');
});

jQuery("body").on('DOMSubtreeModified', ".fixed-col_content", function() 
{
    //alert('changed!!');
});

jQuery('.fixed-col_content').bind('DOMNodeInserted DOMNodeRemoved', function() 
{
  //alert('changed!!!');
});

function homeHeaderSlider()
{
 jQuery('.wcHomeHeaderSlider').slick({
  autoplay: true,
  autoplaySpeed: 2000,
 });
}

function playVid(){
  document.getElementById("ittner-video-id").play();
}
